import type { CaptureStand, PhotosGroupData } from "@/types/types.d";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "@/constants/constants";
import { literals } from "@/constants/literals";
import IconButton from "@/components/buttons/IconButton";

export interface GroupDetailProps {
  group: PhotosGroupData;
  stand: CaptureStand;
}

const HeaderDetail = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="px-6 text-ib-pt-main">
      <label className="text-ib-pt-color-gray-1000">{label}</label>
      <p className="text-ib-pt-color-neutral-800 font-ib-bold">{value}</p>
    </div>
  );
};

const GroupDetail = ({ group, stand }: GroupDetailProps) => {
  const navigate = useNavigate();

  const handleOnEdit = () => {
    const capture = stand ? stand.toLowerCase() : "";
    navigate(`${BASE_URL}/capture/${capture}/edition/${group.id}`);
  };

  return (
    <div className="border p-3 flex flex-col gap-2 h-full">
      <div className="flex">
        <div className=" flex-1 grid grid-cols-2 md:flex md:flex-row md:flex-start">
          <HeaderDetail
            label={literals.photos}
            value={group.photos.length.toString()}
          />
          <HeaderDetail
            label={literals.clientVisible}
            value={group.visibleForClient ? "Si" : "No"}
          />
        </div>
        <div>
          <IconButton
            className="text-ib-pt-color-red-500"
            icon={"pencil"}
            onClick={handleOnEdit}
          />
        </div>
      </div>
      <div className="border-t w-full" />
      <HeaderDetail
        label={literals.description}
        value={group.description || "Sin descripción"}
      />
    </div>
  );
};

export default GroupDetail;
